import { createContext, PropsWithChildren, useContext } from 'react';

import { useTheme } from '@oui/app-core/src/styles';

type StressBreathingTheme = { durationMs: number };

const StressBreathingContext = createContext<StressBreathingTheme>({ durationMs: 60000 });

export function StressBreathingProvider({
  children,
  ...props
}: PropsWithChildren<Partial<StressBreathingTheme>>) {
  // @ts-expect-error
  const { theme } = useTheme();
  return (
    <StressBreathingContext.Provider
      value={{
        durationMs: 60000,
        ...props,
      }}
    >
      {children}
    </StressBreathingContext.Provider>
  );
}

export function useStressBreathingContext() {
  return useContext(StressBreathingContext);
}
